module.exports = __webpack_public_path__ + "static/media/Vector.a82e4d79.svg";